import { render, staticRenderFns } from "./AccountManual.vue?vue&type=template&id=2f16d642&scoped=true&"
import script from "./AccountManual.vue?vue&type=script&lang=js&"
export * from "./AccountManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f16d642",
  null
  
)

export default component.exports